import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import AccordionPanel from "../../components/AccordionPanel";

/**
 * Dumb renderer for the Factsheet accordion.
 * The container wires store-backed parts (e.g. ZoomToGeo) as children.
 */

const FactSheetPanel = ({ children }) => {
  return (
    <AccordionPanel
      defaultExpanded
      summary={
        <Typography style={{ fontWeight: "bold" }}>
          Faktenblatt für Ihre Region
        </Typography>
      }
    >
      <Box>
        <Typography style={{ padding: 10, fontSize: "small" }}>
          Erstellen Sie für den <u>ausgewählten Parameter</u> mit dem
          <u> ausgewählten Zeitabschnitt</u> ein Klima-Faktenblatt für eine
          Region Ihrer Wahl und laden Sie dieses herunter.
          <br />
          <small>
            Voraussetzung ist, dass die Region ausreichend groß ist.
          </small>
        </Typography>
      </Box>

      {children}
    </AccordionPanel>
  );
};

export default FactSheetPanel;
